import { MODAL_UPGRADE_PLAN } from '@components/App/Modal/constants'
import { openModal } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { type GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

// Every upsell in the import modal lands in the same place: the PRO carousel.
// Kept in one hook so the limit notice and the PRO options cannot drift apart —
// they used to open the modal and the pricing page respectively.
export const useUpgradePlan = () => {
  const dispatch = useDispatch()

  return (trigger: GtmTriggerName, description: string) => {
    sendGtmEvent(trigger, description)

    dispatch(
      openModal({
        modalType: MODAL_UPGRADE_PLAN,
        modalProps: {
          planType: 'pro',
        },
      })
    )
  }
}
